import type { GroupedSelectOptions, SelectOptions } from "@/modules/uiKitOverrides/SelectFilter/Select"

import { generateOptionsFromSearchConfigAndFacets } from "@/modules/jobAds/client/utils/generateOptions"
import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"

export const useJobAdsFilterOptionsWithFacets = (
  filterNameFromFacet: string,
  filterNameFromSearchConfig: string
): SelectOptions[] | GroupedSelectOptions[] => {
  const { currentUserSearchConfig, facets } = usePageContext()
  const options = generateOptionsFromSearchConfigAndFacets({
    facets,
    filterNameFromFacet,
    filterNameFromSearchConfig,
    searchConfig: currentUserSearchConfig ? currentUserSearchConfig.searchFilters : [],
  })

  return options
}
